<template>
  <div
    class="desktop-view"
  >
    <transition-group name="page">
      <div
        class="bubbles-wrapper"
        v-if="!status"
        @click="start()"
        key="large-button"
      >
        <span class="bubble-1 animated-bg-1" :class="{'explode': explode, 'hide': !canRender}"></span>
      </div>
      <div
        v-if="status"
        key="qr-code"
        class="qr-code-wrapper delay-entry delay-like-crazy"
        @click="stats()"
      >
        <qrcode class="qr-code" :value="surveyURL" :options="{ width: 400 }"></qrcode>
        <p class="gray-https"><span>https://</span>{{surveyURL.replace(/(^\w+:|^)\/\//, '')}}</p>
      </div>
    </transition-group>
  </div>
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  name: 'Admin',

  data () {
    return {
      explode: false,
      canRender: false,
      shortSID: null
    }
  },

  computed: {
    status () {
      return this.$store.state.admin.play.status
    },
    surveyURL () {      
      return `https://sensata.tk/s/${this.$route.params.sid}`
    }
  },

  methods: {
    start () {
      this.explode = true
      setTimeout(() => {
        this.$store.commit('SET_ADMIN_STATE', { status: 'started' })
      }, 900)
    },
    stats () {
      this.$store.commit('SET_ADMIN_STATE', { status: 'collecting' })
      this.$store.commit('SET_ANALYZE_START_TIMESTAMP', { timestamp: new Date().getTime() })
      this.$store.commit('SET_ANALYZE_END_TIMESTAMP', { timestamp: null })
      this.$router.push(`/survey/${this.$route.params.sid}/analyze`)
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_SURVEY_REFS')
      .then(r => {
        var ret = {};
        var obj = r.fields.refs
        for(var key in obj){
          ret[obj[key]] = key;
        }
        this.shortSID = ret[this.$route.params.sid]
      })
    setTimeout(() => {
      this.canRender = true
    }, 500)
  }
}
</script>

<style scoped lang="scss">
.desktop-view {
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.bubbles-wrapper {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.bubble-1,
.bubble-2,
.bubble-3 {
  opacity: 0.9;
  position: fixed;
  width: 6em;
  height: 6em;
  border-radius: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0.85;
  background: #5d2466;
  box-shadow: 0 0 4em $gray-medium;
  &:hover {
    cursor: pointer;
    transform: scale(1.5);
  }
  transition: all 0.8s ease-in-out;
}
.bubble-1 {
  bottom: -3em;
  left: -3em;
  z-index: 2;
  width: 8em;
  height: 8em;
}
.bubble-2 {
  bottom: -0.9em;
  left: 3em;
  width: 7em;
  height: 7em;
  background: #E229B3;
}
.bubble-3 {
  background: #CD8EFF;
  bottom: 3.3em;
  left: -0.8em;
  width: 8em;
  height: 8em;
}

.animated-bg-1 {
  background: linear-gradient(221deg, #5d2466, #d9188e);
  background-size: 400% 400%;
  -webkit-animation: CirclingBackground 4s ease infinite;
  -moz-animation: CirclingBackground 4s ease infinite;
  animation: CirclingBackground 4s ease infinite;
}
.animated-bg-2x {
  background: linear-gradient(221deg, #5d2466, #d9188e);
  background-size: 400% 400%;
  -webkit-animation: CirclingBackground 4s ease infinite;
  -moz-animation: CirclingBackground 4s ease infinite;
  animation: CirclingBackground 4s ease infinite;
}

.hide {
  opacity: 0;
}
.explode {
  width: 250vh;
  height: 250vh;
  transform: scale(2);
  animation-duration: 0;
  box-shadow: 0 0 0 transparent;
}

.qr-code-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .qr-code {
    transition: transform 0.2s ease-in-out;
    &:hover {
      transform: scale(1.03);
      cursor: pointer;
    }
  }
}
.gray-https {
  span {
    color: rgba($gray-medium, 0.5);
  }
}
</style>
